
import Image from "next/image"

export default function Header({ text, modal = false, modalHandler = false }) {

  var modalClass = ( modal ) ? 'block' : 'hidden';

  return (
    <div className="flex flex-row w-max relative text-3xl cl-foreground pb-">
        <span className="border-b border-dotted border-white pb-1">
          { text }
        </span>
        { modal !== false && modalHandler !== false &&
          <div className={ `${modalClass} flex pb-1 pl-3 font-bold text-white transition hover:text-[#a489c7]` }>
            <Image
              width={20}
              height={20}
              className={"transition cursor-pointer skill-filter skill-filter-hover"}
              src={"svgs/info-icon.svg"}
              alt={"Info Icon"}
              priority={true}
              onClick={ () => modalHandler({ "showModal": true, "mode": modal }) }>
            </Image>
          </div>
        }
    </div>
  );
}